import { formModel } from './formModel.reducer';
import { globals } from './globals.reducer';
import { files } from './file.reducer';
import { validationResults } from './validationResults.reducer';
import { errors } from './errors.reducer';
import { FormBaseStore } from 'sos-common/js/commonTypes/FormBaseStore.types';

// export default combineReducers({researchOrder, globals, registers, files, validationResults});

export function formModelStore(state: FormBaseStore<any>, action: any) {
  const nextGlobals = globals(state.globals, action);
  return {
    formModel: formModel(state.formModel, action, state),
    globals: nextGlobals,
    registers: state.registers,
    files: files(state.files, action),
    validationState: validationResults(state.validationState, action, nextGlobals),
    errors: errors(state.errors, action),
  } as FormBaseStore<any>;
}
